import React, { useState, useEffect, useContext, useRef, useCallback } from "react";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import SearchDropDown from "../../../../ui-components/SearchDropDown";
// material-ui
import { Container, Paper, Typography, Grid, Box } from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
import { Card, Form, Spinner } from "react-bootstrap";
import AppContext from "../../../../context/Context";
import Centrifuge from "centrifuge";
import {
  getHistoryChartDataOptionOI,
  getHolidays,
  getPrice,
  getTicksData
} from "../../../../redux/actions/optionChain";
import moment from "moment";
import { isEmptyObject, timeToLocal, getLocalStorageObject, setLocalStorageObject } from "../../../../util/helper";
import { pickChartPeriods } from "../../../../util/date-calculations";
import { Button } from "antd";
import DropdownSelect from "../../../../ui-components/DropdownSelect";
import { getFullStrikeStocks } from "../../option-chain-table/stock";
import { placeOrdersAction, updateInstrumentConfigAction, getInstrumentConfigAction } from "../../../../redux/actions/brokerAction";
import { Radio, InputNumber, Switch } from "antd";
import { config } from "@fortawesome/fontawesome-svg-core";
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import EastIcon from '@mui/icons-material/East';
import LoderCom from "../../../common/Loder";
import PlusMinQty from "../../../utilities/PlusMinQty";
import Chart from "./chart";
import MultiChartDropdown from '../MultiChartDropdown';
import QuikKeys from './quikKeys';
import { Splitscreen } from "@mui/icons-material";
import { ArrowDown, ArrowLeft, ArrowRight, ArrowUp } from "lucide-react";

const exchange = "NSE";
 
  
const configs = {
 
  tagName:["BUTTON", "SELECT", "INPUT"]
};
// style constant
const useStyles = makeStyles((theme) => ({
  container: {
    width: "100%",
    height: "100%",
    overflowX: "hidden",
  },
  textClass: {
    margin: "1px 4px",
    padding: "1px 4px",
    fontSize: "11px",
    color: ({ isDark }) => (isDark ? "#9da9bb" : "#5e6e82"),
    fontWeight: "bold",
  },
  textHeading: {
    fontSize: "13px",
    margin: "0px 2px",
    color: ({ isDark }) => (isDark ? "#9da9bb" : "#5e6e82"),
    fontWeight: "bold",
    height: "25px",
    textAlign: "center",
    background: ({ isDark }) => (isDark ? "#0a0f16" : "#f0f0f0"),
  },
  strikePaper: {
    height: "450px",
    background: ({ isDark }) => (isDark ? "#121e2d" : "#ffffff"),
  },
  strikeTablePaper: {
    background: ({ isDark }) => (isDark ? "#121e2d" : "#ffffff"),
    marginBottom: "4px",
  },
  stikeContainer: {
    border: ({ isDark }) =>
      isDark ? "1px solid #323232" : "1px solid #f0f0f0",
    background: ({ isDark }) => (isDark ? "#0a0f16" : "#ffffff"),
  },
}));
let localStorageScreenObj = getLocalStorageObject("chart") || {
  
  quikKeys:false,
  ohlc:false,
  chartScreenType:1
};
const AdvanceCharts = ({ dragging, buySellhandle,getInputValues, atmPrice, info, inputValues, height, windowScreen, width, strikeCE, strikePE }) => {
  const {
    config: { isDark },
    setConfig,
  } = useContext(AppContext);
  const chartWrap = useRef();
  const chartFilterWrap = useRef();
  const isKeyUpCount = useRef(0);

  const classes = useStyles({ isDark: isDark });
  const dispatch = useDispatch();
  const optionChainInstrument = useSelector(
    (state) => state.optionChaininstruments.data
  );
  const instrumentConfig = useSelector(
    (state) => state.instrumentConfig.instrumentConfig
  );
  const quikkeys = useSelector(
    (state) => state?.optionChaininstruments?.quikKeys
  );
  const chartType = useSelector(
    (state) => state?.optionChaininstruments?.quikKeys?.chartType
  );

  const [selectedStrikeCE, setselectedStrikeCE] = useState();
  const [selectedStrikePE, setselectedStrikePE] = useState();
  const [strikeArray, setStrikeArray] = useState([]);
  const [optionChainInstrumentsData, setOptionChainInstrumentsData] = useState(
    []
  );
  const [price, setPrice] = useState();
  const [hotkey, setHotkey] = useState(getLocalStorageObject("chart")?.quikKeys || false);
  const [symbolsToStrikePrice, setsymbolsToStrikePrice] = useState();
  const [orderQty, setorderQty] = useState(inputValues?.orderQty || 1);
  const orderQtyRef = useRef();     
  const [middleStrike, setMiddleStrike] = useState();
  const [tradingSymbolST, setTradingSymbolST] = useState();
  const [splitScreen, setsplitScreen] = useState(getLocalStorageObject("chart")?.chartScreenType || 1);
  const debounceValue = useDebounce(orderQty, 2000);
  const [isUpdateQty, setisUpdateQty] = useState(false);
  const [tradeStatus, setTradeStatus] = useState({
    CE: false,
    PE: false,
    Spot: false
  });
  const [spotToken, setSpotToken] = useState();

  useEffect(() => {
 
    // if(!hotkey) {
    //   window.removeEventListener("keyup", handleKeyDown, false); // Succeeds
    //     return () => window.removeEventListener("keyup", handleKeyDown);
    //   } else {
    //     if(selectedStrikeCE && selectedStrikePE && !isKeyUp.current) {
    //       window.addEventListener("keyup", handleKeyDown, true); // Succeed
    //       console.log("isKeyUp.current", isKeyUp.current)
    //       isKeyUp.current = true;

    //     }  
    // }

    if(selectedStrikeCE && selectedStrikePE) {
        window.addEventListener('keyup', handleKeyDown);

        return function () {
        
          window.removeEventListener('keyup', handleKeyDown);
        };
    }

  },[hotkey, selectedStrikeCE, selectedStrikePE])
  useEffect(() => {

    if(quikkeys && Object.keys(quikkeys).length > 0) {
        setsplitScreen(quikkeys.chartScreenType);
        setHotkey(quikkeys.quikKeys)
    }

  },[quikkeys])

  useEffect(() => {
 

    if(orderQtyRef.current != orderQty && isUpdateQty) {

        const param =   {
          "maxLotsPerOrder": parseFloat(inputValues.freezeQty),
          "entryOrderType": inputValues.orderType,
          "entryOrderLimitPercent": inputValues.orderType === "MARKET" ? null : parseFloat(inputValues.marketProtect),
          "exitOrderType": inputValues.exitOrderType,
          "exitOrderLimitPercent": inputValues.exitOrderType === "MARKET" ? null : parseFloat(inputValues.exitmarketProtect),
          "entryOrderLots": parseFloat(orderQty),
          "entryOrderSlPercent": inputValues.stopLossPrice != 0 ? parseFloat(inputValues.stopLossPrice) : null,
          "entryOrderTpPercent": inputValues.targetPrice != 0 ? parseFloat(inputValues.targetPrice) : null,
        };

        if(info.broker.id && info.instrumentToken) {
          dispatch(updateInstrumentConfigAction(info.broker.id, info.instrumentToken,param)).then((data)=>{
            if(data.status) {
              dispatch(getInstrumentConfigAction(info.broker.id ,info.instrumentToken));
              setisUpdateQty(false)
            }

          });
             
            const updatedInputValues = {
              ...inputValues,
              orderQty: orderQty
            };
            orderQtyRef.current = orderQty;
            getInputValues(updatedInputValues,'1');
        }
      }
       
  }, [debounceValue, isUpdateQty]);

  useEffect(() => {
 
    if(inputValues.orderQty) {
      setorderQty(inputValues.orderQty)
      orderQtyRef.current = inputValues.orderQty;
    }
  }, [inputValues]);
  useEffect(() => {
    async function fetchOptionChainInstruments() {
      const {
        optData,
        futToken: futTkn,
        lotSize,
        volumeFreeze,
      } = optionChainInstrument;

      if (optData) {
        setOptionChainInstrumentsData(optData);
      }
      if (futTkn) {
       // setFutToken(futTkn);
      }
    }

    if (
      optionChainInstrument &&
      Object.keys(optionChainInstrument).length > 0
    ) {
      fetchOptionChainInstruments();
    }
  }, [optionChainInstrument]);

     useEffect(() => {
       async function fetchPrice(selectInstrument) {
         setPrice();
         const data = await getPrice(
           selectInstrument,
           selectInstrument == "SENSEX" || selectInstrument == "BANKEX"
             ? "BSE"
             : exchange,
           ""
         );
         if (data && !data?.sessionExpired) {
           const { lp, exchangeToken, token, tradingSymbol } = data;
     
           if (lp && token) {
             setPrice(lp);
             setSpotToken(token);
             setTradingSymbolST(tradingSymbol);
           }
         }
       }
   
       if (info?.instrument) {
         fetchPrice(info?.instrument);
       }
     }, [info]);
     useEffect(() => {
         if(strikeCE) {
         setselectedStrikeCE("")
         setselectedStrikeCE(strikeCE)
        }
        if(strikePE) {
         setselectedStrikePE("")
         setselectedStrikePE(strikePE)
        }
   
     },[strikeCE, strikePE])

     useEffect(() => {
       if (
         optionChainInstrumentsData &&
         optionChainInstrumentsData.length > 0 &&
         price
       ) {
         const { index, middleStrike } = getMiddleStrike(
           optionChainInstrumentsData,
           price
         );
         setselectedStrikeCE(middleStrike);
         setselectedStrikePE(middleStrike);
         setMiddleStrike(middleStrike);
         const { symbolList, symbolsToStrikePrice, strikeList } = getSymbolList(
           optionChainInstrumentsData,
           index,
           parseInt(optionChainInstrumentsData.length / 2)
         );
         setStrikeArray(strikeList);
         setsymbolsToStrikePrice(symbolsToStrikePrice);
       }
     }, [optionChainInstrumentsData, price]);

     const getMiddleStrike = (optionData, price) => {
      let lastIteratePrice = 0;
      let strike = {};
  
      for (let i = 0; i < optionData.length; i++) {
        if (price < optionData[i]?.strikePrice) {
          const middle =
            lastIteratePrice + (optionData[i].strikePrice - lastIteratePrice) / 2;
          if (middle > price) {
            strike = { index: i - 1, middleStrike: lastIteratePrice };
          } else {
            strike = { index: i + 1, middleStrike: optionData[i].strikePrice };
          }
          break;
        }
        lastIteratePrice = optionData[i]?.strikePrice;
      }
      return strike;
    };
    const getSymbolList = (optionData, index, selectStrikes) => {
      const start = Math.max(index - 1 - selectStrikes * 2, 0);
      const end = Math.min(index + selectStrikes * 2, optionData.length);
  
      let symbolList = [];
      let strikeList = new Set();
      let symbolsToStrikePrice = {};
      for (let i = start; i <= end; i++) {
        if(optionData[i]) {
        symbolList.push(optionData[i]?.instrumentToken);
  
        const obj = symbolsToStrikePrice[optionData[i]?.strikePrice] || {};
  
        obj[optionData[i]?.instrumentType] = optionData[i]?.instrumentToken;
        obj["exchangeToken-" + optionData[i]?.instrumentType] =
          optionData[i]?.exchangeToken;
        obj["tradingSymbol-" + optionData[i]?.instrumentType] =
          optionData[i]?.tradingSymbol;
        obj["exchange-" + optionData[i]?.instrumentType] =
          optionData[i]?.exchange;
        obj["lotSize-" + optionData[i]?.instrumentType] = optionData[i]?.lotSize;
        obj["displayName-" + optionData[i]?.instrumentType] =
          optionData[i]?.displayName;
        obj["tickSize-" + optionData[i]?.instrumentType] = optionData[i]?.tickSize;
  
        symbolsToStrikePrice[optionData[i]?.strikePrice] = obj;
        strikeList.add(optionData[i]?.strikePrice);
        }
      }
      // setSymbolsToStrike(symbolsToStrikePrice);
  
      return { symbolList, symbolsToStrikePrice, strikeList: [...strikeList] };
    };
    const handleKeyDown = (e) => {
      if(document.getElementById("hotkey")) {
       var hotkey = document.getElementById("hotkey").value;
       e.preventDefault();
      

     if(!configs.tagName.includes(e.target.tagName))
       if(hotkey === "true") {
          if(e.key === 'ArrowDown') {
               // updateState(String.fromCharCode(8595));
                buySellClick("BUY", "PE", selectedStrikeCE, selectedStrikePE)
              } else if(e.key === 'ArrowUp') {
              //  updateState(String.fromCharCode(8593))
                buySellClick("BUY", "CE", selectedStrikeCE, selectedStrikePE)
              }else if(e.key === 'ArrowRight') {
              //  updateState(String.fromCharCode(8594))
                buySellClick("SELL", "PE", selectedStrikeCE, selectedStrikePE)
              }else if(e.key === 'ArrowLeft') {
              //  updateState(String.fromCharCode(8592))
                buySellClick("SELL", "CE", selectedStrikeCE, selectedStrikePE)
              }
           
          }
        }
         
      };
    const onChangeStrike = (value, type) => {
      if(type === "CE") {
        setselectedStrikeCE(value);
      } else {
        setselectedStrikePE(value);
      }

    };

    const buySellClick = (transactionType, cellType, selectedStrikeCE, selectedStrikePE) => {
  
      const tokenDetail = symbolsToStrikePrice[cellType === "CE" ? selectedStrikeCE : selectedStrikePE];
      
      if(!tokenDetail) {
         console.error("Token detail not found for strike", cellType === "CE" ? selectedStrikeCE : selectedStrikePE);
         return;
      }

      if(document.getElementById("ltp-chart-"+cellType)?.value) {
           const lp = document.getElementById("ltp-chart-"+cellType).value;
           var value = {['lp'+cellType]:lp}
           buySellhandle(transactionType, value, tokenDetail, cellType, cellType === "CE" ? selectedStrikeCE : selectedStrikePE, false, "chart")
     }
    }
    const onSearchStrike = (value) => {};

         const handleFieldChange = (value, name) => {
       setorderQty(value)
       setisUpdateQty(true)
  }

  const handleTradeStatusChange = useCallback((chartType, isTradeable) => {
    console.log(`Trade status changed for ${chartType}:`, isTradeable);
    setTradeStatus(prev => ({
      ...prev,
      [chartType]: isTradeable
    }));
  }, []);

function useDebounce(cb, delay) {
      const [debounceValue, setDebounceValue] = useState(cb);
      useEffect(() => {
        const handler = setTimeout(() => {
          setDebounceValue(cb);
        }, delay);
    
        return () => {
          clearTimeout(handler);
        };
      }, [cb, delay]);
      return debounceValue;
    }

  

  return (
    <div
      ref={chartWrap}
      style={{
     
        height:"100%",
        position: "relative",
      }}
    >
     
        <div>
        
          <div className="d-flex">
             {((splitScreen === 1 || splitScreen === 3 || splitScreen === 2) && (chartType === "CE" || chartType == "")) && 
              <div className="position-relative tv-chart" style={{ flex: "1 1 0%", minWidth: "0" }}>
              <div className="right-border-std" style={{width:"100%", borderRight:"1px solid #c8bdbd"}}>
                    
                   <div className="bottom-btn-">
                      {/* <Typography className={classes.textClass+" text-center"}>
                        Strike   {selectedStrikeCE}
                      </Typography> */}
                      <input type="hidden" id={"ltp-chart-CE"} />
                      {/* <Typography className={classes.textClass+" text-center"}>LTP: <span id={"ltp-chart-"+item.split("-")[1]}>{chartSymbolDataCE.data[item]?.ohlc[chartSymbolDataCE.data[item]?.ohlc.length-1].close?.toFixed(2)}</span></Typography>
                      <Typography className={classes.textClass+" text-center"}>Bid : <span id={"bid-chart-"+item.split("-")[1]}>{tableDataCE[item.split("-")[0]]?.bid?.p?.toFixed(2)}</span></Typography>
                      <Typography className={classes.textClass+" text-center"}>Ask : <span id={"ask-chart-"+item.split("-")[1]}>{tableDataCE[item.split("-")[0]]?.ask?.p?.toFixed(2)} </span></Typography> */}
                    </div>
                {symbolsToStrikePrice && Object.keys(symbolsToStrikePrice).length > 0 && symbolsToStrikePrice[selectedStrikeCE] &&
                     <Chart
                       height={height}
                       type={"CE"}
                       headingText={"Strike CE: " + selectedStrikeCE}
                       width={width}
                       info={info}
                       inputValues={inputValues}
                       instrument={symbolsToStrikePrice[selectedStrikeCE]['tradingSymbol-CE']}
                       token={symbolsToStrikePrice[selectedStrikeCE]['CE']}
                       splitScreen={splitScreen}
                       dragging={dragging}
                       onTradeStatusChange={handleTradeStatusChange}
                     />
                   }
         
                 <div className="bottom-btn">
                   <div className={ 'ltp-b-s-btn'}>                                                    
                             <Button size="small"  type="primary" className="btn btn-success buy-light" onClick={()=>buySellClick("BUY", "CE", selectedStrikeCE, selectedStrikePE)} disabled={!tradeStatus.CE} style={{ width: (splitScreen === 3 || window.innerWidth < 768) && "40px" }}>
                               {hotkey &&  <ArrowUp strokeWidth={2.5} size={18}/>} {(splitScreen === 3 || window.innerWidth < 768) ? "B" : "Buy"}
                             </Button>
                             </div>
                           <div className="order-window-body pt-0 pb-0">
                          <Form.Group className="form-group">
                            <Form.Label className="custom-label"> <span>Qty: {info.lotSize ? info.lotSize*orderQty: 0}</span></Form.Label>
                            <PlusMinQty
                                qtyClick={(qty, value) => {
                                  if(qty > 0) {
                                    handleFieldChange(qty, "orderQty")
                                  }
                              }}
                              filterValue={orderQty}
                              name={"orderQty"}
                              min={1}
                              step={1}
                              isModify={true}
                              page={"header"}
                            />
                          </Form.Group> 
                        </div>
                            <div className={ 'ltp-b-s-btn'}>
                               <Button size="small" type="primary" className="btn btn-danger sell-light" onClick={()=>buySellClick("SELL", 'CE', selectedStrikeCE, selectedStrikePE)} disabled={!tradeStatus.CE} style={{ width: (splitScreen === 3 || window.innerWidth < 768) && "40px" }}>
                                 {hotkey &&  <ArrowLeft strokeWidth={2.5} size={18}/>} {(splitScreen === 3 || window.innerWidth < 768) ? "S" : "Sell"}
                               </Button>
                         </div>
                      <div  className="order-window-body pt-0 pb-0">
                        {selectedStrikeCE &&   (
                           
                            <Form.Group className="form-group">
                              <label className="form-label" style={{ zIndex: 9 }}>
                              CE Strike  
                              </label>
                              <SearchDropDown
                                options={strikeArray}
                                width={90}
                                notFoundText="Strike Not Found!"
                                onSearch={onSearchStrike}
                                onChange={(value) => {
                                  onChangeStrike(value, 'CE');
                                }}
                                size="middle"
                                defaultValue={selectedStrikeCE}
                                valueId="selectedStrikeCE"
                              />
                              {/* {isLoder && isLoderType === "CE" && (
                                <Spinner
                                  className="small-spinner ms-1"
                                  animation="border"
                                  variant="primary"
                                />
                              )} */}
                            </Form.Group>
                        
                        )}
                        
                          
                        </div>
                 
                  </div>
                </div>
                
                  </div>
              }
              {(splitScreen === 3 || chartType === "Spot/Fut") &&
                <div className="position-relative tv-chart" style={{ flex: "1 1 0%", minWidth: "0" }}>
                <div className="right-border-std" style={{width:"100%", borderRight:"1px solid #c8bdbd"}}>
                      
                    {tradingSymbolST && 
                      <Chart
                        height={height}
                        type={"Spot"}
                        headingText={"Spot"}
                        width={width}
                        info={info}
                        inputValues={inputValues}
                        instrument={tradingSymbolST}
                        token={spotToken}
                        splitScreen={splitScreen}
                        dragging={dragging}
                        onTradeStatusChange={handleTradeStatusChange}
                      />
                    }
       <div className="bottom-btn">
         <div className={ 'ltp-b-s-btn  '}>
                   <Button size="small" className="btn btn-success buy-light" disabled style={{ width: splitScreen === 3 && "40px" }}>
                     {splitScreen === 3 ? "B" : "Buy"}
                   </Button>
                   </div>
                 <div className="order-window-body pt-0 pb-0">
                <Form.Group className="form-group">
                  <Form.Label className="custom-label"> <span>Qty: {info.lotSize ? info.lotSize*orderQty: 0}</span></Form.Label>
                  <PlusMinQty
                      qtyClick={(qty, value) => {
                        if(qty > 0) {
                          handleFieldChange(qty, "orderQty")
                        }
                    }}
                    filterValue={orderQty}
                    name={"orderQty"}
                    min={1}
                    step={1}
                    isModify={true}
                    page={"header"}
                  />
                </Form.Group> 
              </div>
                  <div className={ 'ltp-b-s-btn'}>
                     <Button size="small"  className="btn btn-danger sell-light " disabled style={{ width: splitScreen === 3 && "40px" }}>
                       {splitScreen === 3 ? "S" : "Sell"}
                     </Button>
               </div>
        </div>
      </div>
                  
                  </div>  
              }
               {(splitScreen === 2  || splitScreen === 3 || chartType === "PE") &&
                <div className="position-relative tv-chart" style={{ flex: "1 1 0%", minWidth: "0" }}>
                <div className="right-border-std" style={{width:"100%"}}>
                      
                      <div className="bottom-btn-">
                        <input type="hidden" id={"ltp-chart-PE"} />
                      </div>
                    {symbolsToStrikePrice && Object.keys(symbolsToStrikePrice).length > 0 && symbolsToStrikePrice[selectedStrikePE] &&
                      <Chart
                        height={height}
                        type={"PE"}
                        headingText={"Strike PE: " + selectedStrikePE}
                        width={width}
                        info={info}
                        inputValues={inputValues}
                        instrument={symbolsToStrikePrice[selectedStrikePE]['tradingSymbol-PE']}
                        token={symbolsToStrikePrice[selectedStrikePE]['PE']}
                        splitScreen={splitScreen}
                        dragging={dragging}
                        onTradeStatusChange={handleTradeStatusChange}
                      />
                    }
                    <div className="bottom-btn">
                            <div className={ 'ltp-b-s-btn'}>
                             <Button size="small"  type="primary" className="btn btn-success buy-light" onClick={()=>buySellClick("BUY", "PE", selectedStrikeCE, selectedStrikePE)} disabled={!tradeStatus.PE} style={{ width: splitScreen === 3 && "40px" }}>
                               {hotkey &&  <ArrowDown strokeWidth={2.5} size={18}/>} {splitScreen === 3 ? "B" : "Buy"}
                             </Button>
                          <div className="order-window-body pt-0 pb-0">
                            <Form.Group className="form-group">
                              <Form.Label className="custom-label"> <span>Qty: {info.lotSize ? info.lotSize*orderQty: 0}</span></Form.Label>
                              <PlusMinQty
                                  qtyClick={(qty, value) => {
                                    if(qty > 0) {
                                      handleFieldChange(qty, "orderQty")
                                    }
                                }}
                                filterValue={orderQty}
                                name={"orderQty"}
                                min={1}
                                step={1}
                                isModify={true}
                                page={"header"}
                              />
                            </Form.Group> 
                          </div>
                            <div className={ 'ltp-b-s-btn'}>
                             <Button size="small" type="primary" className="btn btn-danger sell-light " onClick={()=>buySellClick("SELL", 'PE', selectedStrikeCE, selectedStrikePE)} disabled={!tradeStatus.PE} style={{ width: splitScreen === 3 && "40px" }}>
                               {hotkey &&  <ArrowRight strokeWidth={2.5} size={18}/>} {splitScreen === 3 ? "S" : "Sell"}
                             </Button>
                       </div>
                      {selectedStrikePE && (
                          <div
                             
                            className="order-window-body pt-0 pb-0"
                          >
                            {(splitScreen === 3 || splitScreen === 2 || chartType === "PE") &&
                            <Form.Group className="form-group me-2">
                              <label className="form-label" style={{ zIndex: 9 }}>
                                PE Strike
                              </label>
                              <SearchDropDown
                                options={strikeArray}
                                width={90}
                                notFoundText="Strike Not Found!"
                                onSearch={onSearchStrike}
                                onChange={(value) => {
                                  onChangeStrike(value,'PE');
                                }}
                                size="middle"
                                defaultValue={selectedStrikePE}
                                valueId="selectedStrikePE"
                              />
                              {/* {isLoder && isLoderType === "PE" && (
                                <Spinner
                                  className="small-spinner ms-1"
                                  animation="border"
                                  variant="primary"
                                />
                              )} */}
                            </Form.Group>
                            }
                            </div>
                      )}

                    </div>
                  
                  
                    </div>
                  </div>  
                </div>
               }
             </div>
        </div>
   
    </div>
  );
};

export default AdvanceCharts;
